import { useAppSelector } from '../../store.model';
import { useDevices } from './useDevices';
import { getAllDevicesIdsByMode } from '../selectors';
import { useAdaptableParams } from '../../../util/hooks/useAdaptableParams';
import _ from 'lodash';

function useDevicesByParams(options?: { deviceIds?: string[] }) {
  const params = useAdaptableParams<{
    deviceId?: string;
    groupId?: string;
    controlUnitId?: string;
  }>();
  const devicesIdsFromParams: string[] = useAppSelector(
    (state) => getAllDevicesIdsByMode(state, { params }),
    _.isEqual
  );
  const devicesIds = options?.deviceIds ?? devicesIdsFromParams;
  const response = useDevices(devicesIds);
  return {
    devicesIds,
    devices: response.data,
    loading: response.isLoading,
    ...response,
  } as const;
}

export default useDevicesByParams;
